import { create } from "apisauce";
import { error } from "../redux/notificationSlice";
import { store } from "../redux/store";
import authSvc from "./auth-service";
import pwaSvc from "./pwa-service";

import spinnerSvc from "./spinner-service";

let isRefreshing = false;
let waitingQueue = [];

export const api = create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { Accept: "application/json" },
});

const processQueue = (error, token = null) => {
  waitingQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  isRefreshing = false;

  waitingQueue = [];
};

api.axiosInstance.interceptors.request.use(
  async (config) => {
    if (navigator.onLine) {
      spinnerSvc.start();
    }

    const token = localStorage.getItem("idToken") || "";

    if (token !== "") {
      config.headers.Authorization = token;
    }

    return config;
  },
  (err) => console.error(err)
);

api.axiosInstance.interceptors.response.use(
  async (response) => {
    spinnerSvc.stop();
    return response;
  },
  async (err) => {
    console.log(navigator.serviceWorker);
    spinnerSvc.stop();
    if (err.message === "Network Error") {
      pwaSvc.saveData(err.config);
    }

    const originalRequest = err?.config;

    if (err.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          waitingQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return api.axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }
      originalRequest._retry = true;
      isRefreshing = true;
      const accessToken = await authSvc.refresh();

      if (accessToken) {
        api.axiosInstance.defaults.headers.common["Authorization"] =
          "Bearer " + accessToken;
        processQueue(null, accessToken);
        return api.axiosInstance(originalRequest);
      } else {
        spinnerSvc.stop();
        authSvc.logout();
        return;
      }
    }

    console.error(err.response.data);

    switch (err.response?.status) {
      case 400:
        spinnerSvc.stop();
        store.dispatch(error(err.response.data.message));
        return err;

      case 401:
        store.dispatch(error("You are unauthorized to perform this action"));
        console.error(err);
        spinnerSvc.stop();
        return;

      case 404:
        store.dispatch(error("Item not found"));
        spinnerSvc.stop();
        return;

      case 500:
        store.dispatch(
          error("Unexpected error please contact your administrator")
        );
        console.error(err);
        spinnerSvc.stop();
        return;

      default:
        store.dispatch(
          error("Unexpected error please contact your administrator")
        );
        spinnerSvc.stop();
        return;
    }
  }
);
